import { render, staticRenderFns } from "./AvailablesPrivadas.vue?vue&type=template&id=507a1662&scoped=true"
import script from "./AvailablesPrivadas.vue?vue&type=script&lang=js"
export * from "./AvailablesPrivadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a1662",
  null
  
)

export default component.exports